/**
 * アコーディオンの開閉
 * HTML構造
 * 　accordion-box
 * 　├ accordion-title
 * 　└ accordion-contents
 * @param accordion_target  HTML object
 * @param active_status  true: 開いている
 * @constructor
 */
export default function AccordionSwitch(accordion_target, active_status) {
    if (active_status) {
        accordion_target.find(".accordion-contents").slideUp();
        accordion_target.find(".accordion-title").removeClass("active");
    } else {
        accordion_target.find(".accordion-contents").slideDown();
        accordion_target.find(".accordion-title").addClass("active");
    }
}